import { render, staticRenderFns } from "./code-form.vue?vue&type=template&id=1943f3ce&"
import script from "./code-form.vue?vue&type=script&lang=js&"
export * from "./code-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports